// Header sticky and menu functionality
const kbHeader = document.querySelector('#kb-header');

if (kbHeader) {
  const topHeader = kbHeader.querySelector('.top-header');
  const mainHeader = kbHeader.querySelector('.main-header');
  const menuButton = kbHeader.querySelector('.kb-menu-button');

  // Cache header heights
  const topHeaderHeight = topHeader?.clientHeight || 0;
  const mainHeaderHeight = mainHeader?.clientHeight || 0;

  // Toggle mobile menu
  menuButton?.addEventListener('click', () => {
    kbHeader.classList.toggle('kb-menu-active');
  });

  // Sticky header with debounced scroll
  let ticking = false;
  const handleScroll = () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        kbHeader.classList.toggle('sticky', window.scrollY > topHeaderHeight);
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', handleScroll, { passive: true });

  // Set CSS custom properties
  const setHeaderProperties = () => {
    document.documentElement.style.setProperty('--top-header-height', `${topHeaderHeight}px`);
    document.documentElement.style.setProperty('--top-header-minus', `-${topHeaderHeight}px`);
    document.documentElement.style.setProperty('--main-header-height', `${mainHeaderHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${topHeaderHeight + mainHeaderHeight}px`);
  };

  setHeaderProperties();
  window.addEventListener('resize', setHeaderProperties);
}

// Slick slider initialization
jQuery(($) => {
  $('.product-cart-slider').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
  });
});

// Menu pagination
const menu = document.querySelector('.kb-menu ul');

if (menu) {
  const initializeMenu = () => {
    const maxVisible = 5;
    let currentPage = 0;
    const items = Array.from(menu.querySelectorAll('li:not(.kb-more-btn):not(.kb-back-btn)'));
    const totalPages = Math.ceil(items.length / maxVisible);

    // Create navigation buttons
    const backBtn = document.createElement('li');
    backBtn.classList.add('kb-back-btn');
    backBtn.innerHTML = '<a href="#" aria-label="Previous page">Go Back</a>';
    menu.prepend(backBtn);

    const moreBtn = document.createElement('li');
    moreBtn.classList.add('kb-more-btn');
    moreBtn.innerHTML = '<a href="#" aria-label="Next page">More</a>';
    menu.append(moreBtn);

    const renderPage = (page) => {
      const start = page * maxVisible;
      items.forEach((item, index) => {
        item.style.display = index >= start && index < start + maxVisible ? '' : 'none';
      });
      backBtn.style.display = page > 0 ? '' : 'none';
      moreBtn.style.display = page < totalPages - 1 ? '' : 'none';
    };

    // Event listeners
    backBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (currentPage > 0) {
        renderPage(--currentPage);
      }
    });

    moreBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (currentPage < totalPages - 1) {
        renderPage(++currentPage);
      }
    });

    // Initial render
    renderPage(currentPage);
  };

  // Initialize after DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMenu);
  } else {
    initializeMenu();
  }
}
